import React from 'react';

export const LoadingSpinner = ({ message = 'Loading...', fullPage = false }) => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: fullPage ? '120px 24px' : '48px 24px',
    gap: 16,
  };

  const spinnerStyle = {
    width: 40,
    height: 40,
    border: '3px solid #E8ECF0',
    borderTopColor: '#0D9488',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  };

  return (
    <div style={containerStyle}>
      <div style={spinnerStyle} />
      <div style={{ fontSize: 14, color: '#6B7280', fontWeight: 500 }}>{message}</div>
    </div>
  );
};

export const ErrorCard = ({ message = 'Something went wrong', onRetry }) => (
  <div className="card" style={{ textAlign: 'center', padding: '48px 24px' }}>
    <div style={{ fontSize: 48, marginBottom: 12, opacity: 0.5 }}>{'\u26A0\uFE0F'}</div>
    <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 4 }}>
      Error
    </div>
    <div style={{ fontSize: 14, color: 'var(--text-secondary)', marginBottom: onRetry ? 16 : 0 }}>
      {message}
    </div>
    {onRetry && (
      <button className="btn-primary" onClick={onRetry}>
        Try Again
      </button>
    )}
  </div>
);
